import { ACTIONS } from '../actions/reservations'

export type ReservationStatus = 'IN_PROGRESS' | 'CANCELED' | 'EXPIRED'

export interface ReservationItem {
  id: number
  renter_id: number
  unique_product_id: number
  reserved_at: string
  expires_at: string
  status: ReservationStatus
  product_name: string | null
  product_code: string | null
  image: string | null
  price_ht: number | null
  barcode_uid: string | null
  quality: string | null
}

interface ReservationsState {
  items: ReservationItem[]
  loading: boolean
  creating: boolean
  error?: any
  releasingIds: number[]
}

export const initialReservationsState: ReservationsState = {
  items: [],
  loading: false,
  creating: false,
  error: undefined,
  releasingIds: [],
}

const reservationsReducer = (
  state = initialReservationsState,
  action
): ReservationsState => {
  switch (action.type) {
    case ACTIONS.GET_RESERVATIONS_REQUEST:
      return { ...state, loading: true, error: undefined }
    case ACTIONS.GET_RESERVATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.items || [],
      }
    case ACTIONS.GET_RESERVATIONS_FAILURE:
      return { ...state, loading: false, error: action.error }
    case ACTIONS.RELEASE_RESERVATION_REQUEST:
      return {
        ...state,
        releasingIds: [...state.releasingIds, action.id],
      }
    case ACTIONS.RELEASE_RESERVATION_SUCCESS:
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.id),
        releasingIds: state.releasingIds.filter((id) => id !== action.id),
      }
    case ACTIONS.RELEASE_RESERVATION_FAILURE:
      return {
        ...state,
        error: action.error,
        releasingIds: state.releasingIds.filter((id) => id !== action.id),
      }
    case ACTIONS.CREATE_RESERVATION_REQUEST:
      return { ...state, creating: true, error: undefined }
    case ACTIONS.CREATE_RESERVATION_SUCCESS:
      return {
        ...state,
        creating: false,
        items: [action.item, ...state.items],
      }
    case ACTIONS.CREATE_RESERVATION_FAILURE:
      return { ...state, creating: false, error: action.error }
    case ACTIONS.RESET_RESERVATIONS:
      return { ...initialReservationsState }
    default:
      return state
  }
}

export default reservationsReducer
